export default __webpack_public_path__ + "static/media/radio-mark.41773bed.svg";